import React from "react";
import "./allvideo.css";

import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

const AllVideo = () => {
  const [Video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);

  // ENCRYPTION VIDEO LINK
  const secretKey = "sachin";
  const encryptFilename = (filename) => {
    return CryptoJS.AES.encrypt(filename, secretKey).toString();
  };
  const decryptFilename = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  useEffect(() => {
    axios
      //   .get(`https://topfaculty.co.in/api/video_fetch.php?TeacherId=${id}`)
      .get(`https://viasacademy.com/viasapi/vedioapi.php`)
      .then((response) => {
        console.log(response.data);
        setVideo(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error Fetching Video Data", error);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div id="rs-latest-news-style7"   className="rs-courses-details ">
         <img
          src="assetsfront/images/allvid.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row mt-4">
            <h2 className="title text-center">
              🎥 TopFaculty.co.in{" "}
              <strong style={{ color: "#f7b205" }}> All Videos</strong>
            </h2>

            <div className="video-grid">
              {loading ? (
                <span
                  style={{
                    fontWeight: "bold",
                    color: "#002347",
                    fontSize: "30px",
                  }}
                >
                  Please Wait
                  <span className="dot-loader">
                    {[...Array(9)].map((_, i) => (
                      <span className="dot" key={i}></span>
                    ))}
                  </span>
                </span>
              ) : Video && Video.length > 0 ? (
                Video.map((video, index) => (
                  // Video Card
                  <div className="video-card" key={index}>
                    <div className="video-thumb">
                      <img
                        src="assetsfront/images/thub2.png"
                        alt="Video Thumbnail"
                      />
                      {(() => {
                        const encrypted = encryptFilename(video.VideoFilename);
                        return (
                          <Link
                            to={`/runningvideo/${encodeURIComponent(
                              encrypted
                            )}/${encodeURIComponent(video.VideoName)}`}
                            key={index}
                          >
                            <div className="play-button" />
                          </Link>
                        );
                      })()}
                    </div>
                    <div className="video-info">
                      <div className="video-title">(1).{video.VideoName}</div>
                      <div className="video-meta">
                        10K views • Date: {video.CreatedDate}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center" }}>No video available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllVideo;
